import React from "react";

type Props = {
  title: string;
  subtitle: string;
};

const SignInSectionTitle = (props: Props) => {
  return (
    <h1 className="text-4xl font-bold tracking-wider uppercase text-blue-800">
      {props.title} <br />{" "}
      <span className="text-3xl text-blue-500">{props.subtitle}</span>
    </h1>
  );
};

export default SignInSectionTitle;
